import React, { Component, Fragment, createRef } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Step1 from './signup_steps/Step1';
import Wizard from './helpers/signupWizard';

class SignupDRPForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            pdfUrl: false,
            SignupDRPFormItems: null,
            submitted: false,
            drp: false
        }
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const emailAddress = urlParams.get('emailAddress');
        this.setState({
            ...this.state,
            emailAddress: emailAddress ? emailAddress : null,
            drp: document.getElementById('sign-up-drp-form') ? true : false
        });
    }

    onSubmit = async (values) => {
        const reactState = this;
        const { drp } = reactState.state;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        values.formType = 'signUp';
        values.guid = false;
        values.userType = this.props.selectedUser;
        values.indication = drp ? 'Dementia' : 'Parkinsons';
        try {
            await Axios({
                method: 'post',
                url: url + "api/signup",
                data: values,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (res) {
              reactState.setState({
                ...reactState.state,
                submitted: true
              });
            });
        }
        catch(errors) {
            console.log("errors", errors)
        }
        reactState.scrollToTop();
    }

    scrollToTop = ()=> {
		this.toTop.current.scrollIntoView({ behavior: "smooth" }); 
	}

    toTop = createRef();

    render() {
        const { submitted, emailAddress, drp } = this.state;

        return (
            <div className="acadia-form drp-signup-form" ref={this.toTop}>
                <Wizard onSubmit={this.onSubmit} noOfPages={0} submitted={submitted} toTop={this.toTop}>
                    <Wizard.Page>
                        <Step1 emailAddress={emailAddress} drp={drp} />
                    </Wizard.Page>
                </Wizard>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  const { questionOptions } = state;
  return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(SignupDRPForm);